import { ListItemIcon, ListItemText, styled, Typography } from '@mui/material';
import { List, ListItem } from '../../../components/List';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';

function Attachments() {
    return (
        <>
            <UnderlinedText>
                Ces pièces sont à envoyer par e-mail à l'adresse suivante :{' '}
                <strong>admin@esaj.asso.fr</strong>
            </UnderlinedText>
            <List>
                <ListItem>
                    <ListItemIcon>
                        <AttachFileOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText
                        primary="Attestation du diplôme le plus élevé, ou les deux relevés de notes les plus
                        récents"
                    />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <AttachFileOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText
                        secondary="(passeport ou carte nationale d’identité + carte de séjour
                        pour les étudiants de nationalité étrangère résidant en France)"
                        primary="Pièce d’identité"
                    />
                </ListItem>
            </List>

            <WarningText variant="h4">
                <WarningIconContainer>
                    <WarningAmberOutlinedIcon fontSize="small" />
                </WarningIconContainer>
                Seuls les dossiers complets seront examinés.
            </WarningText>
        </>
    );
}

const UnderlinedText = styled(Typography)(({ theme }) => ({ textDecoration: 'underline' }));
const WarningIconContainer = styled('div')(({ theme }) => ({
    marginRight: theme.spacing(3),

    display: 'flex',
    alignItems: 'center',
}));
const WarningText = styled(Typography)(({ theme }) => ({
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
}));
export { Attachments };
